import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { format_display_fancy_notime_withDay, toInt, format } from '../Utils';
import { Grid, Divider, ListItemText, TextField, InputAdornment } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import { UserService } from '../Services/UserService';
import moment from 'moment';
import { Typeahead } from 'react-bootstrap-typeahead';
import { DeliveryService } from '../Services/DeliveryService';
import { ReasonService } from '../Services/ReasonService';
import { REASON_TYPE } from '../Constants';
import ItemSelection from './ItemSelection';

const useStyles = makeStyles(theme => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    sectionHeading: {
        fontSize: theme.typography.pxToRem(16),
        fontWeight: theme.typography.fontWeightMedium,
    },
    heading: {
        fontSize: theme.typography.pxToRem(14),
        fontWeight: theme.typography.fontWeightMedium,
    },
    subheading: {
        fontSize: theme.typography.pxToRem(14),
        fontWeight: theme.typography.fontWeightRegular,
        textAlign: "left"
    },
    subheadingLink: {
        fontSize: theme.typography.pxToRem(14),
        fontWeight: theme.typography.fontWeightRegular,
        textAlign: "left",
        color: "blue",
        textDecoration: "underline",
        cursor: "pointer"
    }
}));

const DialogTitle = (props => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles(theme => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
    root: {
        margin: 0,
        padding: theme.spacing(1),
    },
}))(MuiDialogActions);

export default function MarkCustomerDelivery(props) {
    const [open, setOpen] = React.useState(props.customer ? true : false);
    const [loading, setLoading] = React.useState(false);

    const [details, setDetails] = React.useState([]);
    const [agents, setAgents] = React.useState([]);
    const [cnReasons, setCNReasons] = React.useState([]);
    const [showReasonList, setShowReasonList] = React.useState([]);

    const [newDelivery, setNewDelivery] = React.useState({});
    const [selectedAgent, setSelectedAgent] = React.useState(undefined);

    const [deliveryDetails, setDeliveryDetails] = React.useState({});
    const classes = useStyles();

    React.useEffect(() => {
        Promise.all([UserService.getAgentList("1"), ReasonService.getReasonByType(REASON_TYPE.CREDITNOTE)])
            .then((datas) => {
                console.log(datas);
                if(datas[0]){
                    setAgents(datas[0].users);
                }
                if(datas[1]){
                    setCNReasons(datas[1].reasons)
                }
            });
    }, []);

    React.useEffect(() => {
        setOpen(props.open);
    }, [props.customer && props.open]);

    React.useEffect(() => {
        console.log(props);
        if (props.customer !== undefined) {
            setNewDelivery(props.customer);
            if (props.customer.expected_delivery_agent_id) {
                setSelectedAgent(agents.filter(a => a.id === props.customer.expected_delivery_agent_id)[0]);
            }
        }
    }, [props.customer]);

    React.useEffect(() => {
        if (open && newDelivery.id && newDelivery.schedule_date) {
            let deliveryDetails = {};
            deliveryDetails.away = "-1"
            deliveryDetails.transaction_id = newDelivery.transaction_id;
            deliveryDetails.customer_id = newDelivery.id;
            deliveryDetails.location = "";
            deliveryDetails.route_id = newDelivery.route_id;
            deliveryDetails.schedule_date = newDelivery.schedule_date;
            deliveryDetails.signature = undefined;
            deliveryDetails.customer_type = 'CUSTOMER'
            deliveryDetails.total_balance_count = 0;
            deliveryDetails.total_delivered_count = 0;
            deliveryDetails.total_returned_count = 0;
            deliveryDetails.delivered_from = 'Web';
            deliveryDetails.stats_list = [];

            setLoading(true);
            DeliveryService.getCustomerDeliveries(newDelivery.id, moment(newDelivery.schedule_date).startOf('day'), moment(newDelivery.schedule_date).startOf('day'), 0, 100000)
            .then((data) => {
                console.log(data);
                if (data.delivery_schedule && data.delivery_schedule.length > 0) {
                        let srList = []
                        let product_list = [];
                        let deliveries = data.delivery_schedule.filter(d => d.transaction_id === newDelivery.transaction_id && d.id === newDelivery.id && d.schedule_date === newDelivery.schedule_date && d.invoice_no === '' && d.delivery_date === null);

                        deliveries.forEach((delivery, index) => {
                            let product_entry = {};
                            product_entry.bottles_returned = 0;
                            product_entry.p_id = delivery.product_id;
                            product_entry.product_qty = toInt(delivery.product_qty);
                            product_entry.returned_count = 0;
                            product_entry.return_reason = null;
                            product_entry.delivered_count = toInt(delivery.product_qty);
                            product_entry.s_id = delivery.schedule_id;
                            product_entry.product_name = delivery.product_name
                            product_list.push(product_entry);
                            srList.push({p: delivery.product_id, show: product_entry.returned_count > 0})
                        });

                        deliveryDetails.product_list = product_list;
                        setShowReasonList(srList)
                    }
                    setDeliveryDetails(deliveryDetails);
                    setLoading(false);
                    setDetails(details);
                })
                .catch(error => {
                    console.log(error);
                    setLoading(false);
                });
        }
    }, [open]);

    const handleSave = () => {
        if(isValid()){
            props.showConfirmDialog("Confirm Mark Delivery?", undefined, () => {
                deliveryDetails.delivery_date = moment().utc().format(format);
                deliveryDetails.total_delivered_count = deliveryDetails.product_list.reduce(function (accumulator, currentValue) {
                    return accumulator + toInt(currentValue.delivered_count || 0);
                }, deliveryDetails.total_delivered_count);
                deliveryDetails.total_returned_count = deliveryDetails.product_list.reduce(function (accumulator, currentValue) {
                    return accumulator + toInt(currentValue.returned_count || 0);
                }, deliveryDetails.total_returned_count);
                console.log(deliveryDetails);
                props.showProgressDialog('Marking Delivery...');
                props.closeConfirmDialog();
                setLoading(true);
                save();
    
            });
        } else {
            props.showSnackBar('Please select Reasons for the Returns','error')
        }
    }

    const isValid = () => {
        let valid = false;
        let pL = deliveryDetails.product_list.filter(p => toInt(p.returned_count) > 0 && p.return_reason === null);
        if(pL.length === 0){
            valid = true;
        }
        return valid;
    }

    const save = () => {
        let header = { 'user-id': props.user.id, 'user-name': props.user.name };
        deliveryDetails.product_list = deliveryDetails.product_list.map(p => ({ ...p, returned_count: (p.returned_count || 0), delivered_count: (p.delivered_count || 0), return_reason: p.return_reason || null }));
        let body = { rows: [deliveryDetails] }
        DeliveryService.markDeliveryV2(selectedAgent.id, header, body)
            .then((data) => {
                props.showSnackBar(`Marked Delivered.`, 'success');
                if (props.save) {
                    props.save();
                }
                handleClose();
                setLoading(false);
                props.closeProgressDialog();
            })
            .catch((err) => {
                console.log(err);
                props.showSnackBar(`Failed to Mark Delivery. Please check again or contact Admin.`, 'error');
                setLoading(false);
                props.closeProgressDialog();
            });
    }

    const handleClose = () => {
        props.close();
        setDetails([]);
        setNewDelivery({})
        setDeliveryDetails({})
        setShowReasonList([])
        setSelectedAgent(undefined);
        setOpen(false);
    };

    return (
        <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open} fullWidth maxWidth="md">
            <DialogTitle id="customized-dialog-title" onClose={handleClose} classes={classes}>
                Marking Delivery : {newDelivery.name}
                <Typography variant="button" id="modal-title" color="secondary">
                    <br />
                [NOTE] Your marking the delivery on behalf of the agent
            </Typography>
            </DialogTitle>
            <DialogContent dividers>
                {/* <Fade
                    in={loading}
                    style={{
                        transitionDelay: loading ? '10ms' : '0ms'
                    }}
                    unmountOnExit
                >
                    <LinearProgress style={{ height: 5, width: "100%" }} color="secondary" />
                </Fade> */}
                <Grid container justify="flex-start" alignItems="flex-start" direction="row" style={{ minHeight: 300 }}>
                    <Grid item container xs={12} lg={12} key={"header"} spacing={2} alignItems="center">
                        <Grid item xs={6} lg={6}>
                            <Typography className={classes.heading} style={{ textAlign: 'left' }}>customer</Typography>
                        </Grid>
                        <Grid item xs={6} lg={6}>
                            <Typography className={classes.heading} style={{ textAlign: 'left' }}>{newDelivery.name}</Typography>
                        </Grid>
                        <Grid item xs={6} lg={6}>
                            <Typography className={classes.heading} style={{ textAlign: 'left' }}>Schedule Date</Typography>
                        </Grid>
                        <Grid item xs={6} lg={6}>
                            <Typography className={classes.heading} style={{ textAlign: 'left' }}>{newDelivery.schedule_date && moment(newDelivery.schedule_date).format(format_display_fancy_notime_withDay)}</Typography>
                        </Grid>
                        <Grid item xs={6} lg={6}>
                            <Typography className={classes.heading} style={{ textAlign: 'left' }}>Select Agent</Typography>
                        </Grid>
                        <Grid item xs={6} lg={6}>
                            <Typeahead
                                onChange={(selected) => {
                                    setSelectedAgent(selected[0]);
                                }}
                                id="typeahead-id-mark-delivery"
                                options={agents}
                                labelKey="name"
                                placeholder="Choose Delivery Agent"
                                clearButton
                                defaultSelected={selectedAgent && [selectedAgent]}
                            />
                        </Grid>
                        <Grid item xs={12} lg={12}>
                            <Divider />
                        </Grid>
                        <Grid item xs={12} lg={12}>
                            <Typography className={classes.heading} style={{ textAlign: 'left' }}>Products</Typography>
                        </Grid>
                        <Grid item xs={12} lg={12}>
                            <Divider variant="middle" />
                        </Grid>
                    </Grid>
                    {
                        deliveryDetails && deliveryDetails.product_list &&
                        deliveryDetails.product_list.map((delivery, index) => {
                            let l = showReasonList.find(s => s.p === delivery.p_id);
                            let showReason = l ? l.show : false;
                            return(
                                <Grid item container xs={12} lg={12} key={index} spacing={2} alignItems="center" style={{ paddingTop: 8, paddginBottom: 8 }}>
                                    <Grid item xs={2} lg={1}>
                                        <Typography className={classes.subheading} style={{ textAlign: 'left' }}>{index + 1}</Typography>
                                    </Grid>
                                    <Grid item xs={10} lg={3}>
                                        <ListItemText
                                            primary={<Typography className={classes.subheading} style={{ textAlign: 'left' }}>{delivery.product_name}</Typography>}
                                            secondary={<Typography className={classes.subheading} style={{ textAlign: 'left' }}>Scheduled Qty {delivery.product_qty}</Typography>}
                                        />
                                    </Grid>
                                    <Grid item xs={6} lg={2}>
                                        <TextField
                                            label={"Deliveried Qty"}
                                            placeholder={"Delivered Qty"}
                                            name={delivery.p_id}
                                            defaultValue={delivery.product_qty}
                                            margin="normal"
                                            variant="outlined"
                                            onChange={(e) => {
                                                let p = deliveryDetails.product_list.find(p => p.p_id === delivery.p_id);
                                                p.delivered_count = toInt(e.target.value);
                                                setDeliveryDetails(deliveryDetails);
                                            }}
                                            InputProps={{
                                                endAdornment: <InputAdornment position="end">Nos</InputAdornment>,
                                                inputProps: { min: 0, step: 1 }
                                            }} />
                                    </Grid>
                                    {
                                        false &&
                                        <Grid item xs={6} lg={2}>
                                            <TextField
                                                label="Returned Count"
                                                placeholder="Returned Count"
                                                name={delivery.p_id}
                                                defaultValue={delivery.returned_count || 0}
                                                margin="normal"
                                                variant="outlined"
                                                onChange={(e) => {
                                                    let p = deliveryDetails.product_list.find(p => p.p_id === delivery.p_id);
                                                    let r = showReasonList.find(s => s.p === delivery.p_id)
                                                    p.returned_count = toInt(e.target.value);
                                                    r.show = p.returned_count > 0;
                                                    setDeliveryDetails(deliveryDetails);
                                                    setShowReasonList(prev => [...prev, r]);
                                                }}
                                                InputProps={{
                                                    endAdornment: <InputAdornment position="end">Nos</InputAdornment>,
                                                    inputProps: { min: 0, step: 1 }
                                                }} />
                                        </Grid>
                                    }
                                    <Grid item xs={6} lg={3}>
                                        {
                                            showReason && (
                                                <ItemSelection 
                                                    required 
                                                    label='Reason'
                                                    size="medium" 
                                                    error={delivery.returned_count > 0 && delivery.return_reason === null}
                                                    value={cnReasons.find(c => c.reason === delivery.return_reason) || null} 
                                                    optionLabel='reason' 
                                                    options={cnReasons} 
                                                    selected={(reason) => {
                                                        let p = deliveryDetails.product_list.find(p => p.p_id === delivery.p_id);
                                                        p.return_reason = reason.reason;
                                                        setDeliveryDetails(deliveryDetails);
                                                    }}/>
                                            )
                                        }
                                    </Grid>
                                    <Grid item xs={12} lg={12}>
                                        <Divider variant="fullWidth" />
                                    </Grid>
                                </Grid>
                            )

                        })
                    }
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button autoFocus onClick={handleSave} disabled={loading} color="primary">
                    Mark Delivery
                </Button>
                <Button autoFocus onClick={handleClose} disabled={loading} color="secondary">
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
}